import type { Base_Bus } from '../Base/Base.Bus'
import { Sync_sync, Sync_stop } from '../Sync/Sync.initialise'

export function E2E_initialize(bus: Base_Bus) {
    window.addEventListener('E2E_StartSync', () => {
        Sync_sync('E2E sync', bus)
        bus.addTask('device_sync', 'E2E sync')
    })

    window.addEventListener('E2E_StopSyncing', () => {
        Sync_stop()
    })

    // This helper is for trying out selectors for use with page.waitForXPath
    window.xPath = (selector: string) => {
        const nodes: Node[] = []
        const iterator = document.evaluate(selector, document, null, XPathResult.ORDERED_NODE_ITERATOR_TYPE, null)

        let thisNode = iterator.iterateNext()
        while (thisNode) {
            nodes.push(thisNode)
            thisNode = iterator.iterateNext()
        }

        return nodes
    }
}
